import React from 'react';
import {SigninForm} from "../../../components/admin/SigninForm/SigninForm";
import styles from './Signin.module.scss'

export const Signin = () => {
    return <>
        <SigninForm/>
    </>
};
